import {
    request as addBannerRequest,
    error as addBannerError,
    finish as addBannerFinish,
} from './reducers/add-new-banner';

import {
    request as uploadBannerImageRequest,
    error as uploadBannerImageError,
    finish as uploadBannerImageFinish,
} from './reducers/upload-banner-image';

import {
    request as getAllBannersRequest,
    error as getAllBannersError,
    finish as getAllBannersFinish,
} from './reducers/get-all-banners';

import {
    request as updateBannerRequest,
    error as updateBannerError,
    finish as updateBannerFinish,
} from './reducers/update-banner';

import {
    request as deleteBannerRequest,
    error as deleteBannerError,
    finish as deleteBannerFinish,
} from './reducers/delete-banner';

import {
    request as updateBannerSliderRequest,
    error as updateBannerSliderError,
    finish as updateBannerSliderFinish,
} from './reducers/update-banner-slide-time';

import {
    request as getBannerConfigRequest,
    error as getBannerConfigError,
    finish as getBannerConfigFinish,
} from './reducers/get-banner-config';

import {
    error as changePromotionOrderError,
    finish as changePromotionOrderFinish,
    request as changePromotionOrder,
} from './reducers/change-promotion-order';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    GET_ALL_BANNERS_REQUEST: getAllBannersRequest,
    GET_ALL_BANNERS_ERROR: getAllBannersError,
    GET_ALL_BANNERS_FINISH: getAllBannersFinish,
    ADD_NEW_BANNER_REQUEST: addBannerRequest,
    ADD_NEW_BANNER_ERROR: addBannerError,
    ADD_NEW_BANNER_FINISH: addBannerFinish,
    UPLOAD_BANNER_IMAGE_REQUEST: uploadBannerImageRequest,
    UPLOAD_BANNER_IMAGE_ERROR: uploadBannerImageError,
    UPLOAD_BANNER_IMAGE_FINISH: uploadBannerImageFinish,
    UPDATE_BANNER_REQUEST: updateBannerRequest,
    UPDATE_BANNER_ERROR: updateBannerError,
    UPDATE_BANNER_FINISH: updateBannerFinish,
    DELETE_BANNER_REQUEST: deleteBannerRequest,
    DELETE_BANNER_ERROR: deleteBannerError,
    DELETE_BANNER_FINISH: deleteBannerFinish,
    UPDATE_BANNER_SLIDE_TIME_REQUEST: updateBannerSliderRequest,
    UPDATE_BANNER_SLIDE_TIME_ERROR: updateBannerSliderError,
    UPDATE_BANNER_SLIDE_TIME_FINISH: updateBannerSliderFinish,
    GET_BANNER_CONFIG_REQUEST: getBannerConfigRequest,
    GET_BANNER_CONFIG_ERROR: getBannerConfigError,
    GET_BANNER_CONFIG_FINISH: getBannerConfigFinish,
    CHANGE_PROMOTION_ORDER_REQUEST: changePromotionOrder,
    CHANGE_PROMOTION_ORDER_ERROR: changePromotionOrderError,
    CHANGE_PROMOTION_ORDER_FINISH: changePromotionOrderFinish,
});
